exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".tertiary--container--19uLgCFA {\r\n  text-align: center;\r\n  background-color: #F2F2F2;\r\n}\r\n\r\n.tertiary--header--2Gs4NzXY {\r\n  color: #E97600;\r\n}\r\n\r\n.tertiary--contentCol--XRjYi3d2 {\r\n  padding-bottom: 28px;\r\n}\r\n\r\n", "", {"version":3,"sources":["C:/Users/mhaf3/ss/SeekerV2/src/components/start/tertiary/tertiary.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,0BAA0B;CAC3B;;AAED;EACE,eAAe;CAChB;;AAED;EACE,qBAAqB;CACtB","file":"tertiary.css","sourcesContent":[".container {\r\n  text-align: center;\r\n  background-color: #F2F2F2;\r\n}\r\n\r\n.header {\r\n  color: #E97600;\r\n}\r\n\r\n.contentCol {\r\n  padding-bottom: 28px;\r\n}\r\n\r\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"container": "tertiary--container--19uLgCFA",
	"header": "tertiary--header--2Gs4NzXY",
	"contentCol": "tertiary--contentCol--XRjYi3d2"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"sourceMap":true,"importLoaders":1,"localIdentName":"[name]--[local]--[hash:base64:8]"}!./src/components/start/tertiary/tertiary.css
// module id = 426
// module chunks = 0